import { gql, TypedDocumentNode } from '@apollo/client'

import { GAM_SETUP_ORDER_FRAGMENT } from './fragment'
import { Data, Variables } from './types'

export const GET_GAM_SETUP_ORDERS: TypedDocumentNode<Data, Variables> = gql`
  ${GAM_SETUP_ORDER_FRAGMENT}

  query getGoogleAdManagerSetupOrders($workspaceId: ID!) {
    node(id: $workspaceId) {
      ... on Workspace {
        gamSetupOrders {
          ...GamSetupOrderFragment
        }
      }
    }
  }
`
